import React from 'react';
import { Table as AntTable, Space, Avatar, Popconfirm, Input, Button, Modal, message } from 'antd';
import { useState, useRef } from "react";
import { UserOutlined, SearchOutlined } from '@ant-design/icons';
import { genNumberTable } from '../../../../function/genNumberTable';
import { useStateContext } from '../../../../contexts/ContextProvider';
import { UseFetchApproveLeaveDay,UseFetchDeleteLeaveDay } from '../hooks/useFetch';
import { JOB_TYPE,USER_ROLE } from '../../../../data/constant';

const headerStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "black",
};

const Table = ({ data, loading,  refresh }) => {
  const { currentColor } = useStateContext();
  const [setSearchText] = useState('');
  const [setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const userRole = localStorage.getItem('userRole');
  const job_type = sessionStorage.getItem('jobType') || 0;
  const { mutateAsync: approveLeaveday } = UseFetchApproveLeaveDay();
  const { mutateAsync: deleteLeaveday } = UseFetchDeleteLeaveDay();

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const handlePreviewImage = (imgUrl) => {
    setPreviewImage(imgUrl);
    setPreviewOpen(true);
  };

  const onApprove = async (record) => {
    try {
      const payload = {
        id: record.holiday_id,
      }
      const result = await approveLeaveday(payload);
      if (result) {
        message.success("Approve Leave Day Success");
      }
    } catch (error) {
      console.log(error);
    } finally {
      refresh();
    }
  };

  const onDelete = async (record) => {
    try {
      const result = await deleteLeaveday(record.holiday_id);
      if (result) {
        message.success("Delete Leave Day Success");
      }
    } catch (error) {
      console.log(error);
    } finally {
      refresh();
    }
  };

  const columns = [
    {
      title: 'ลำดับ',
      align: 'center',
      width: 60,
      dataIndex: 'number',
      key: 'number',
      onHeaderCell: () => { return { style: headerStyle } }
    },
    {
      title: 'UserName',
      align: 'center',
      dataIndex: 'userName',
      key: 'userName',
      onHeaderCell: () => { return { style: headerStyle } },
      // render: (caseName) => {
      //   return <span style={{ fontSize: '16px',fontWeight: 'bold', color: getCaseNameColor(caseName) }}>{caseName.toUpperCase()}</span>;
      // },
      ...getColumnSearchProps('caseName'),
    },
    {
      title: 'วันที่',
      align: 'center',
      dataIndex: 'date',
      key: 'date',
      onHeaderCell: () => { return { style: headerStyle } },
      ...getColumnSearchProps('date'),
    },
    {
      title: 'ประเภทวันหยุด',
      align: 'center',
      dataIndex: 'holidayType',
      key: 'holidayType',
      onHeaderCell: () => { return { style: headerStyle } },
      ...getColumnSearchProps('holidayType'),
    },
    {
      title: 'Note',
      align: 'center',
      dataIndex: 'note',
      key: 'note',
      onHeaderCell: () => { return { style: headerStyle } },
      render: (note) => {
        if (!note || note === '-') return '-';
        return (
          <div style={{
            whiteSpace: 'pre-wrap',
            textAlign: 'left',
            maxWidth: '200px',
            wordBreak: 'break-word'
          }}>
            {note}
          </div>
        );
      }
    },
    {
      title: 'คนสร้าง',
      dataIndex: 'create_by',
      key: 'create_by',
      align: 'center',
      onHeaderCell: () => ({ style: headerStyle }),
    },
    {
      title: 'วันที่สร้าง',
      dataIndex: 'createdAt',
      key: 'createdAt',
      align: 'center',
      onHeaderCell: () => ({ style: headerStyle }),
    },
    {
      title: 'รูปภาพ',
      dataIndex: 'imgs',
      key: 'imgs',
      align: 'center',
      onHeaderCell: () => ({ style: headerStyle }),
      render: (imgs) => {
        if (!imgs || imgs.length === 0) return '-';
        return (
          <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
            {imgs.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`img-${index}`}
                style={{
                  width: '40px',
                  height: '40px',
                  objectFit: 'cover',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  border: '1px solid #ddd'
                }}
                onClick={() => handlePreviewImage(img)}
              />
            ))}
          </div>
        );
      }
    },
    {
      title: 'การจัดการ',
      fixed: 'right',
      key: 'actions',
      align: 'center',
      render: (record) => (
        <Space size="middle">
          {userRole != USER_ROLE.employee ? (
            <>
              <Popconfirm
                title="อนุมัติวันหยุด"
                description={`ยืนยันการอนุมัติวันหยุด ${record.userName} ?`}
                onConfirm={() => onApprove(record)}
                okText="ยืนยัน"
                cancelText="ยกเลิก"
                //okButtonProps={{ style: { backgroundColor: currentColor, borderColor: currentColor } }}
              >
                <Button type="primary">Approve</Button>
              </Popconfirm>
            </>
          ) : (
            null
          )}
          {job_type == JOB_TYPE.head || job_type == JOB_TYPE.manager || userRole != USER_ROLE.employee ? (
            <Popconfirm
              title="ลบวันหยุด"
              description={`ยืนยันการลบวันหยุด ${record.userName} ?`}
              onConfirm={() => onDelete(record)}
              okText="ยืนยัน"
              cancelText="ยกเลิก"
            >
              <Button type="primary" danger>ลบ</Button>
            </Popconfirm>
          ) : (
            null
          )}
        </Space>
      ),
      onHeaderCell: () => ({ style: headerStyle }),
    }
  ];

  return (
    <div className='overflow-x-auto'>
      <AntTable
        loading={loading}
        className='border-1 rounded-lg border-gray-200'
        dataSource={genNumberTable(data)}
        columns={columns}
        //pagination={{ pageSize: 8 }} 
        rowKey={'id'}
        scroll={{ x: 'max-content' }}
      />
      <Modal
        open={previewOpen}
        //title={previewImage}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
      >
        <img
          alt="example"
          style={{
            width: '100%',
          }}
          src={previewImage}
        />
      </Modal>
    </div>
  );
};

export default Table;
